import { PaginationData, UserCommon } from 'constants/interface';
import {
  buildPaginationParams,
  getPaginationHeaders,
  PaginatedResponse,
  requestClient,
} from 'infra/request';

export interface CreateUserData {
  name: string
  email: string
  // TODO: remove when password mailing is working
  password: string
  isAdmin: boolean
  isActive: boolean
}

export interface UpdateUserData {
  id: string
  data: {
    name: string
    email: string
    isAdmin: boolean
    isActive: boolean
  }
}

export interface UserApi {
  create(userData: CreateUserData): Promise<UserCommon>
  update(userData: UpdateUserData): Promise<UserCommon>
  getList(filter: PaginationData): Promise<PaginatedResponse<UserCommon>>
}

const userApiBuilder = (): UserApi => {
  const create = async (userData: CreateUserData): Promise<UserCommon> => {
    const params: Record<string, unknown> = {};
    params.name = userData.name;
    params.email = userData.email;
    params.password = userData.password;
    params.is_active = userData.isActive;
    params.is_admin = userData.isAdmin;
    const result = await requestClient.post('/users', params);

    const createdUser: UserCommon = result.data as UserCommon;
    return createdUser;
  };

  const update = async (userData: UpdateUserData): Promise<UserCommon> => {
    const { id: userId, data } = userData;
    const params: Record<string, unknown> = { ...data };
    params.name = data.name;
    params.email = data.email;
    params.is_active = data.isActive;
    params.is_admin = data.isAdmin;
    const result = await requestClient.put(`/users/${userId}`, params);
    const updatedUser = result.data as UserCommon;
    return updatedUser;
  };

  const getList = async (filterData: PaginationData): Promise<PaginatedResponse<UserCommon>> => {
    const params = buildPaginationParams(filterData);
    const result = await requestClient.get('/users', params);
    const pagination = getPaginationHeaders(result);
    const usersList: UserCommon[] = result.data;
    return {
      pagination,
      data: usersList,
    };
  };

  return {
    create,
    update,
    getList,
  };
};

export const userApi = userApiBuilder();
